<template>
  <div class="contacts-page">
    <div class="container">
      <div class="row contacts-page_title">
        <div class="col">
          <Title current-name="Контакты">
            Контакты
          </Title>
        </div>
      </div>
      <div class="row contacts-page_row">
        <div class="col-12 col-md-6 col-lg-5">
          <div class="contacts-page_phone">
            <p>Call-центр службы доставки:</p>
            <a
              :href="'tel:' + $region.getPhone()"
              @click="$store.dispatch('events/phoneClick')"
              class="s-phone"
            >
              {{ $region.getPhone() }}
            </a>
            <small>Режим работы: {{ $region.get('workTimeString') }}</small>
            <a :href="requisites" target="_blank" class="button button_mid button_icon d-flex d-md-none">
              <font-awesome-icon :icon="['fas', 'download']" />
              Скачать реквизиты
            </a>
          </div>
          <MicroBanner />
        </div>
        <div class="col-12 col-md-6 col-lg-7">
          <div class="contacts-page_list">
            <div class="contacts-page_item">
              <strong>Отдел развития корпоративной сети</strong>
              <!--              <p></p>-->
              <a href="mailto:i.zhigalin@setsushi.ru ">i.zhigalin@setsushi.ru </a>
            </div>
            <div class="contacts-page_item">
              <strong>Отдел персонала</strong>
              <p>Работа в команде СУШИСЕТ</p>
              <a href="mailto:hr@setsushi.ru ">hr@setsushi.ru</a>
            </div>
            <div class="contacts-page_item">
              <strong>Франчайзинг</strong>
              <p>По вопросам партнёрства:</p>
              <a href="mailto:fr@setsushi.ru">fr@setsushi.ru</a>
            </div>
            <div class="contacts-page_item">
              <strong>Отдел маркетинга</strong>
              <p>Предложения по рекламному сотрудничеству:</p>
              <a href="mailto:marketing@setsushi.ru ">marketing@setsushi.ru </a>
            </div>
            <div class="contacts-page_item">
              <strong>Отдел закупок</strong>
              <p>Коммерческие предложения от поставщиков</p>
              <a href="mailto:sushi_set@mail.ru">sushi_set@mail.ru</a>
            </div>
            <div class="contacts-page_item d-none d-md-flex">
              <a :href="requisites" target="_blank" class="button button_mid button_icon">
                <font-awesome-icon :icon="['fas', 'download']" />
                Скачать <br>реквизиты
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contacts-page_wbt">
      <WillBeinTouch :short="true" />
    </div>
    <div class="container">
      <ContactsForm />
    </div>
    <Modal :open="modalOpen" @close="modalOpen = false" :initialWidth="'504px'" :borderless="true">
      <contacts-success />
    </Modal>
  </div>
</template>

<script>
import Title from '@/components/UI/Title'
import MicroBanner from '@/components/page/BannerMicro'
import Button from '@/components/UI/Button'
import WillBeinTouch from '@/components/page/WillBeInTouch'
import ContactsForm from '@/components/page/ContactsForm'
import { mapState } from 'vuex'
import { getPhoneByUtm } from '~/utils/getPhoneByUtm'
import Modal from '~/components/page/Modal/Modal'
import ContactsSuccess from '~/components/popup/ContactsSuccess'

export default {
  components: { ContactsSuccess, Modal, Title, MicroBanner, Button, WillBeinTouch, ContactsForm },
  head () {
    return {
      title: 'Контактная информация ресторанов и службы доставки СУШИСЕТ',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Контактная информация, режим работы, ссылки на социальные сети службы доставки японской и итальянской кухни СУШИСЕТ. Мы на связи!',
        },
      ],
    }
  },
  data () {
    return {
      modalOpen: false,
      phoneNumber: '+7 (495) 150-55-22',
    }
  },
  computed: {
    ...mapState({
      requisites: state => state.config.requisites,
    }),
    status () {
      return this.$store.getters['dictionaries/getStatus']
    },
  },
  watch: {
    status (newValue) {
      switch (newValue) {
        case 'contact-form-successfully-fetched':
          this.modalOpen = true
          break
      }
    },
  },
  mounted () {
    this.phoneNumber = getPhoneByUtm()
  },
}
</script>

<style lang="less">
.contacts-page {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding-bottom: 57px;
  overflow-x: hidden;
  margin-top: 20px;

  a.button {
    color: #fff;
  }

  .banner-micro {
    width: 100%;
  }

  @media screen and (max-width: 1200px) {
    padding-bottom: 42px;
  }
  @media screen and (max-width: 768px) {
    padding-bottom: 23px;
  }

  &_row {
    margin-bottom: 40px;

    @media screen and (max-width: 1200px) {
      margin-bottom: 35px;
    }
    @media screen and (max-width: 768px) {
      margin-bottom: 29px;
    }

    .col-12 {
      &:nth-child(1) {
        @media screen and (max-width: 768px) {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 29px;
        }
      }
    }
  }

  &_title {
    margin-bottom: 28px;

    @media screen and (max-width: 768px) {
      margin-bottom: 16px;
    }
  }

  &_phone {
    margin-bottom: 22px;

    @media screen and (max-width: 768px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 29px;
    }

    p {
      font-family: 'Roboto Slab', Arial, sans-serif;
      font-weight: 500;
      font-size: 16px;
      padding-bottom: 10px;

      @media screen and (max-width: 768px) {
        text-align: center;
      }
    }

    a.s-phone {
      display: inline-block;
      font-family: 'Roboto', Arial, sans-serif;
      font-size: 40px;
      font-style: italic;
      color: #FF6A00;
      text-decoration: none;
      padding-bottom: 10px;

      @media screen and (max-width: 768px) {
        text-align: center;
      }
    }

    small {
      display: block;
      font-family: 'Roboto', Arial, sans-serif;
      font-weight: 300;
      font-size: 14px;

      @media screen and (max-width: 768px) {
        text-align: center;
        padding-bottom: 20px;
      }
    }

    .button {
      max-width: 100%;
      width: 285px;
    }
  }

  &_list {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
  }

  &_item {
    max-width: 50%;
    flex-basis: 50%;
    margin-bottom: 20px;

    @media screen and (max-width: 1200px) {
      margin-bottom: 17px;
    }
    @media screen and (max-width: 768px) {
      max-width: 100%;
      flex-basis: 100%;
      margin-bottom: 0;

      &:not(:last-child) {
        margin-bottom: 20px;
      }
    }

    strong {
      display: block;
      font-family: 'Roboto Slab', Arial, sans-serif;
      font-weight: 500;
      font-size: 30px;
      padding-bottom: 6px;

      @media screen and (max-width: 1200px) {
        font-size: 25px;
      }
      @media screen and (max-width: 992px) {
        font-size: 18px;
      }
      @media screen and (max-width: 768px) {
        font-size: 30px;
      }
    }

    p {
      font-family: 'Roboto', Arial, sans-serif;
      font-weight: 300;
      font-size: 14px;
      font-style: italic;
      padding-bottom: 4px;
    }

    a {
      font-family: 'Roboto', Arial, sans-serif;
      font-weight: 300;
      font-size: 14px;
      font-style: italic;
      color: #003CFF;
    }

    .button {
      font-style: italic;
    }
  }

  .banner-micro_img img {
    left: -27px;

    @media screen and (max-width: 1200px) {
      left: 4px;
    }
    @media screen and (max-width: 992px) {
      left: -25px;
    }
    @media screen and (max-width: 768px) {
      left: 4px;
    }
    @media screen and (max-width: 540px) {
      left: usnet;
      right: 5px;
    }
  }

  &_wbt {
    margin-bottom: 30px;

    @media screen and (max-width: 768px) {
      display: none;
    }
  }
}
</style>
